// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginLayoutMessage__container-e75e8e {
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  margin-bottom: 8px;
}

.LoginLayoutMessage__type-success-ebb4b9 {
  color: var(--success-40);
}

.LoginLayoutMessage__type-error-abe622 {
  color: var(--danger-40);
}

.LoginLayoutMessage__type-info-ab8c69 {
  color: var(--info-40);
}

.LoginLayoutMessage__type-warning-b61d25 {
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/layouts/LoginLayout/LoginLayoutMessage/LoginLayoutMessage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[".container {\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-bottom: 8px;\n}\n\n.type-success {\n  color: var(--success-40);\n}\n\n.type-error {\n  color: var(--danger-40);\n}\n\n.type-info {\n  color: var(--info-40);\n}\n\n.type-warning {\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoginLayoutMessage__container-e75e8e`,
	"type-success": `LoginLayoutMessage__type-success-ebb4b9`,
	"typeSuccess": `LoginLayoutMessage__type-success-ebb4b9`,
	"type-error": `LoginLayoutMessage__type-error-abe622`,
	"typeError": `LoginLayoutMessage__type-error-abe622`,
	"type-info": `LoginLayoutMessage__type-info-ab8c69`,
	"typeInfo": `LoginLayoutMessage__type-info-ab8c69`,
	"type-warning": `LoginLayoutMessage__type-warning-b61d25`,
	"typeWarning": `LoginLayoutMessage__type-warning-b61d25`
};
module.exports = ___CSS_LOADER_EXPORT___;
